import { Component, OnInit } from '@angular/core';

import { ExportAsService, ExportAsConfig } from 'ngx-export-as';

import { BaseService } from '../../base.service';
import { ConfigService } from '../../config.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  model: any = {};

  exportInvoiceConfig: ExportAsConfig = {
    type: 'xlsx', // the type you want to download
    elementId: 'Invoice_Table', // the id of html/table element,
    options: { // html-docx-js document options
      orientation: 'landscape',
      margins: {
        top: '20'
      }
    }
  };


  p: number = 1;

  displayAll:boolean=false;
  itemPerPage:any=10;

  constructor(public exportAsService: ExportAsService,public _baseService: BaseService, public _config: ConfigService) { }

  ngOnInit() {
    this._baseService.getAllProducts();
  }

  onSubmit() {

  }



  exportInvoice() {
    
    // download the file using old school javascript method
    this.exportAsService.save(this.exportInvoiceConfig, 'Pending_Items').subscribe(() => {
      // save started
    });

  }



}
